/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SessionInformation'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SessionInformation'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SessionInformationApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SessionInformation);
  }
}(this, function(ApiClient, SessionInformation) {
  'use strict';

  /**
   * SessionInformation service.
   * @module api/SessionInformationApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SessionInformationApi. 
   * @alias module:api/SessionInformationApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sessionInformationChangePartnerCompanyGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationChangePartnerCompanyGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SessionInformation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * changePartnerCompany
     * @param {String} _4SAPIAppID 
     * @param {Integer} partnerCompanyID 
     * @param {module:api/SessionInformationApi~sessionInformationChangePartnerCompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SessionInformation}
     */
    this.sessionInformationChangePartnerCompanyGet = function(_4SAPIAppID, partnerCompanyID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationChangePartnerCompanyGet";
      }

      // verify the required parameter 'partnerCompanyID' is set
      if (partnerCompanyID == undefined || partnerCompanyID == null) {
        throw "Missing the required parameter 'partnerCompanyID' when calling sessionInformationChangePartnerCompanyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'partnerCompanyID': partnerCompanyID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SessionInformation;

      return this.apiClient.callApi(
        '/SessionInformation/changePartnerCompany', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationChangeSessionToGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationChangeSessionToGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SessionInformation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * changeSessionTo
     * @param {String} _4SAPIAppID 
     * @param {Integer} userID 
     * @param {module:api/SessionInformationApi~sessionInformationChangeSessionToGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SessionInformation}
     */
    this.sessionInformationChangeSessionToGet = function(_4SAPIAppID, userID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationChangeSessionToGet";
      }

      // verify the required parameter 'userID' is set
      if (userID == undefined || userID == null) {
        throw "Missing the required parameter 'userID' when calling sessionInformationChangeSessionToGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'userID': userID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SessionInformation;

      return this.apiClient.callApi(
        '/SessionInformation/changeSessionTo', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationClearWorkshopLanguageCodeGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationClearWorkshopLanguageCodeGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clearWorkshopLanguageCode
     * @param {String} _4SAPIAppID 
     * @param {module:api/SessionInformationApi~sessionInformationClearWorkshopLanguageCodeGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sessionInformationClearWorkshopLanguageCodeGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationClearWorkshopLanguageCodeGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SessionInformation/clearWorkshopLanguageCode', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationLoadGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SessionInformation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {module:api/SessionInformationApi~sessionInformationLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SessionInformation}
     */
    this.sessionInformationLoadGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SessionInformation;

      return this.apiClient.callApi(
        '/SessionInformation/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationLoadInitialDataGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationLoadInitialDataGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadInitialData
     * @param {String} _4SAPIAppID 
     * @param {module:api/SessionInformationApi~sessionInformationLoadInitialDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.sessionInformationLoadInitialDataGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationLoadInitialDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/SessionInformation/loadInitialData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationRevertSessionBackGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationRevertSessionBackGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * revertSessionBack
     * @param {String} _4SAPIAppID 
     * @param {module:api/SessionInformationApi~sessionInformationRevertSessionBackGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.sessionInformationRevertSessionBackGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationRevertSessionBackGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/SessionInformation/revertSessionBack', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationSetInitialStartingPointGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationSetInitialStartingPointGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setInitialStartingPoint
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.initialStartingPoint1 
     * @param {Integer} opts.workshopID 
     * @param {Integer} opts.dialogID 
     * @param {module:api/SessionInformationApi~sessionInformationSetInitialStartingPointGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sessionInformationSetInitialStartingPointGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationSetInitialStartingPointGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'initialStartingPoint1': opts['initialStartingPoint1'],
        'workshopID': opts['workshopID'],
        'dialogID': opts['dialogID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SessionInformation/setInitialStartingPoint', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationSetLanguageGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationSetLanguageGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setLanguage
     * @param {String} _4SAPIAppID 
     * @param {String} lang 
     * @param {module:api/SessionInformationApi~sessionInformationSetLanguageGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sessionInformationSetLanguageGet = function(_4SAPIAppID, lang, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationSetLanguageGet";
      }

      // verify the required parameter 'lang' is set
      if (lang == undefined || lang == null) {
        throw "Missing the required parameter 'lang' when calling sessionInformationSetLanguageGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'lang': lang
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SessionInformation/setLanguage', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sessionInformationSetWorkshopLanguageCodeGet operation.
     * @callback module:api/SessionInformationApi~sessionInformationSetWorkshopLanguageCodeGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setWorkshopLanguageCode
     * @param {String} _4SAPIAppID 
     * @param {Integer} workshopID 
     * @param {String} languageCode 
     * @param {module:api/SessionInformationApi~sessionInformationSetWorkshopLanguageCodeGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sessionInformationSetWorkshopLanguageCodeGet = function(_4SAPIAppID, workshopID, languageCode, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sessionInformationSetWorkshopLanguageCodeGet";
      }

      // verify the required parameter 'workshopID' is set
      if (workshopID == undefined || workshopID == null) {
        throw "Missing the required parameter 'workshopID' when calling sessionInformationSetWorkshopLanguageCodeGet";
      }

      // verify the required parameter 'languageCode' is set
      if (languageCode == undefined || languageCode == null) {
        throw "Missing the required parameter 'languageCode' when calling sessionInformationSetWorkshopLanguageCodeGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'workshopID': workshopID,
        'languageCode': languageCode
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SessionInformation/setWorkshopLanguageCode', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
